(function(){
"use strict";
var doc=document, root=doc.documentElement;
var reduced=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
doc.documentElement.classList.remove("no-js"); doc.documentElement.classList.add("js");

/* ---------------------------------------------------------- ELEMENT EXPLORER */
(function(){
  var grid=doc.getElementById("elGrid"); if(!grid) return;
  var filters=doc.getElementById("elFilters"), panel=doc.getElementById("elPanel");

  var E=[
    {s:"SA",n:"Salicylic acid",c:"Keratolytic",p:"30%",
     t:"The follicular plug, and the inflammation around it.",
     m:"Lipophilic, so it partitions out of water and into a sebum-filled follicle rather than sitting on the surface. There it acts as a desmolytic — breaking the protein bridges holding dead keratinocytes together — and modulates the arachidonic acid cascade that produces the redness around a lesion.",
     f:"Held at pH 3.0 in our peels so that roughly half of it exists as free, non-ionised acid: the only form lipid-permeable enough to reach the follicle.",
     i:["Excelerate 15% / 30%","Inflacin Serum","Salicylic Gel","Pore Control Cleanser","Renewal Facial Cleanser","Chemical Peel Spray","Follicure"]},
    {s:"GA",n:"Glycolic acid",c:"Keratolytic",p:"10%",
     t:"Surface roughness, dullness, and the fibroblast underneath.",
     m:"The smallest alpha-hydroxy acid, and water-soluble — it loosens corneocyte adhesion at the surface rather than in the pore. At depth it is reported to stimulate fibroblasts toward collagen and glycosaminoglycan production.",
     f:"Paired with salicylic and mandelic acid in the Renewal cleanser so three molecular weights work at three depths in one contact time.",
     i:["Glycolic Gel","Chemical Peel Spray","Renewal Facial Cleanser","Dermalytic"]},
    {s:"MA",n:"Mandelic acid",c:"Keratolytic",p:"1%",
     t:"The top of the stratum corneum, slowly.",
     m:"A large, comparatively lipophilic AHA. Its size slows penetration, which is exactly the point: it extends the exfoliating gradient upward without adding sting.",
     f:"Included at a low percentage as the gentlest step of a three-acid gradient, not as a headline.",
     i:["Renewal Facial Cleanser"]},
    {s:"LA",n:"Lactic acid",c:"Keratolytic",p:"10%",
     t:"Thickened, scaling body skin.",
     m:"Keratolytic at treatment strength and a component of the skin's own natural moisturising factor at lower ones — it loosens and hydrates in the same pass.",
     f:"Combined with glycolic acid and urea in a petrolatum-and-lanolin base for the body, where the stratum corneum is far thicker than on the face.",
     i:["Dermalytic"]},
    {s:"UR",n:"Urea",c:"Keratolytic",p:"20%",
     t:"Compacted keratin — calluses, scale, keratosis pilaris.",
     m:"Concentration decides behaviour. Low percentages act as a humectant; at twenty percent urea dissolves the intercellular matrix of the stratum corneum, softening hardened keratin while driving water into the tissue.",
     f:"Dosed at the keratolytic end deliberately. It is why Dermalytic is a body product and not a face one.",
     i:["Dermalytic"]},

    {s:"RE",sn:"HPR retinoid ester",n:"Hydroxypinacolone retinoate",c:"Retinoid",p:"3%",
     t:"The retinoid receptor, directly.",
     m:"A retinoic acid ester that binds retinoid receptors without the conversion steps ordinary retinol must pass through. Renewal is up-regulated at the basal layer with markedly less of the irritation those conversion steps cost.",
     f:"Chosen over retinol precisely so we can prescribe a serious retinoid to people who have already failed one. Dosed at 3% in the Retinol Serum and at 0.5% in Inflacin, where it is a supporting act rather than the lead.",
     i:["Retinol Serum","Inflacin Serum","Time Freeze Eye Serum","Dark Circle Eye Serum","Collagen Serum"]},
    {s:"BK",n:"Bakuchiol",c:"Retinoid",p:"1%",
     t:"The signal that switches pigment production on.",
     m:"Reported to act upstream of tyrosinase up-regulation — at the alpha-melanocyte-stimulating-hormone step — and to support retinoid-responsive renewal pathways with a tolerability profile that suits reactive skin.",
     f:"It is the first of Litaderm's four positions on the pigment pathway: intervene before the enzyme is ever switched on.",
     i:["Litaderm Serum"]},

    {s:"NC",n:"Niacinamide",c:"Pigment",p:"10%",
     t:"Three things at once: pigment hand-off, ceramide supply, inflammatory tone.",
     m:"Interrupts the transfer of melanosomes from melanocyte to keratinocyte, so pigment already made is not distributed. Separately, it increases ceramide synthesis and modulates inflammatory cytokine signalling.",
     f:"Used at 10% where pigment is the target and 4% where its job is to buffer a stronger active. Both are working concentrations; neither is decorative.",
     i:["Litaderm Serum","Inflacin Serum","Collagen Serum","Retinol Serum","DermNourish"]},
    {s:"AZ",n:"Azelaic acid",c:"Pigment",p:"10%",
     t:"Overactive melanocytes, and C. acnes.",
     m:"A dicarboxylic acid that modulates tyrosinase and is reported to act preferentially on hyperactive melanocytes rather than normally functioning ones. It is also bacteriostatic against C. acnes — which is why it earns its place in a serum aimed at both pigment and redness.",
     f:"At 10%, the concentration at which the literature evaluates it — and stacked with three other pigment-pathway actives rather than sold alone.",
     i:["Litaderm Serum"]},
    {s:"AR",n:"Alpha arbutin",c:"Pigment",p:"4%",
     t:"Tyrosinase, competitively.",
     m:"Occupies the enzyme that converts tyrosine into melanin, reducing synthesis at the source without bleaching what is already there.",
     f:"Alpha arbutin rather than a cruder hydroquinone derivative, at a concentration that does useful work in a formula tolerable enough for daily use across all skin tones.",
     i:["Litaderm Serum"]},

    {s:"ZP",n:"Zinc pyrithione",c:"Microbiome",p:"2%",
     t:"Malassezia in the follicle; the scalp and body microbiome.",
     m:"Particulate and substantive — it deposits into the follicular infundibulum and leaves a superficial reservoir that remains present after rinsing, which is why contact time matters and why a wash can be therapeutic.",
     f:"Paired with salicylic acid in Follicure so the acid dissolves the scale and the zinc reaches what is underneath it.",
     i:["Medi-Zinc Cleanser","Follicure"]},
    {s:"ZN",n:"Zinc PCA",c:"Microbiome",p:"1%",
     t:"Sebum output at the enzyme.",
     m:"Reported to modulate 5-alpha-reductase activity in the sebaceous gland, reducing production rather than mopping up the result.",
     f:"Included in Inflacin so the serum addresses the fuel as well as the plug — a mattifying powder addresses neither.",
     i:["Inflacin Serum"]},

    {s:"EB",sn:"4-Ethoxy­benzaldehyde",n:"4-Ethoxybenzaldehyde",c:"Vascular",p:"3%",
     t:"Prostaglandin E2 — the mediator behind flushing.",
     m:"Reported to inhibit the release of PGE2, and with it the vasodilation and vascular hyperpermeability that make redness visible and persistent.",
     f:"An unusual, specific choice. Most redness products reach for soothing botanicals; this targets a named mediator instead.",
     i:["DermRepair"]},
    {s:"K1",sn:"Vitamin K1",n:"Vitamin K1 · phylloquinone",c:"Vascular",p:"1%",
     t:"Visible vessels, bruising, and blue-toned dark circles.",
     m:"Reported to support clearance of extravasated blood pigment and to contribute to vessel wall integrity — which is why it appears in both a post-procedure cream and an eye serum.",
     f:"Fat-soluble, so it is carried in a lipid-rich Medilan™ base built to take it down to where the capillaries are.",
     i:["DermRepair","Dark Circle Eye Serum"]},
    {s:"PA",n:"d-Panthenol",c:"Vascular",p:"—",
     t:"Skin under repair.",
     m:"Converts in skin to pantothenic acid, a component of coenzyme A, supporting the cellular metabolism of repair. Also humectant in its own right.",
     f:"Present across the range as a quiet constant — the ingredient that makes an aggressive protocol survivable.",
     i:["DermNourish","Enriched","Pore Control Cleanser","Inflacin Serum"]},
    {s:"AL",n:"Medical-grade aloe",c:"Vascular",p:"—",
     t:"The neurosensory sting of a strong BHA.",
     m:"Acts as a biological buffer against the stinging sensation high-strength beta-hydroxy acids provoke, without raising the pH and disarming the acid.",
     f:"This is the whole philosophy in one ingredient: solve tolerance in the vehicle, never by weakening the dose.",
     i:["Pore Control Cleanser"]},

    {s:"VC",sn:"THD ascorbate · vit C",n:"Tetrahexyldecyl ascorbate",c:"Antioxidant",p:"10%",
     t:"The fibroblast, and the collagen it assembles.",
     m:"Lipid-soluble, so it associates with the lipid-rich stratum corneum instead of struggling at the surface. Intracellularly it converts to ascorbic acid, the cofactor several enzymes require to assemble the collagen triple helix.",
     f:"Roughly an order of magnitude more expensive than L-ascorbic acid, and stable — no low-pH sting, no bottle turning brown by week three.",
     i:["Collagen Serum"]},
    {s:"CQ",sn:"Ubiquinone · CoQ10",n:"Ubiquinone · CoQ10",c:"Antioxidant",p:"—",
     t:"Mitochondrial oxidative stress, and collagenase.",
     m:"A mitochondrial antioxidant reported to inhibit MMP-1 activity — the collagenase that degrades collagen after UV exposure. Protecting existing collagen is cheaper than rebuilding it.",
     f:"Placed in the sunscreens rather than sold as a serum, because that is where the oxidative insult actually happens.",
     i:["Dermdefence SPF 50","Dermatint SPF 50"]},

    {s:"CE",sn:"Physiological lipids",n:"Ceramides · cholesterol · fatty acids",c:"Barrier",p:"—",
     t:"The lamellar bilayer — the mortar between the bricks.",
     m:"Supplied together, in the arrangement the stratum corneum actually uses, so the barrier is rebuilt rather than merely covered. A competent barrier is what makes transepidermal water loss stop and actives become tolerable.",
     f:"All three, not one. A ceramide on its own is a marketing ingredient; the set is a repair.",
     i:["Enriched"]},
    {s:"ML",sn:"Medilan™ lanolin",n:"Medilan™ medical lanolin",c:"Barrier",p:"—",
     t:"Severely compromised, cracked or post-procedure skin.",
     m:"An ultra-pure lanolin fraction that closely mimics human skin lipids, used as an occlusive and emollient where the barrier has genuinely failed.",
     f:"Ordinary lanolin is a well-known contact allergen, which is why most brands avoid it entirely. The pharmacopoeial grade is the reason we did not have to.",
     i:["Enriched","DermRepair"]},
    {s:"HA",n:"Hyaluronic acid",c:"Barrier",p:"2%",
     t:"Water, held where it is useful.",
     m:"Molecular weight decides everything. High-weight HA does not cross the epidermis; very low-weight fractions can be pro-inflammatory. The intermediate fraction penetrates without provoking.",
     f:"Specified by weight, not just by name — which is unusual enough that almost nobody else prints it.",
     i:["DermNourish","Collagen Serum"]},

    {s:"TS",sn:"Bemotrizinol",n:"Bemotrizinol · Tinosorb S",c:"Photoprotection",p:"—",
     t:"UVA and UVB — and the stability of the other filters.",
     m:"A broad-spectrum organic filter that both absorbs and disperses UV energy, and photostabilises avobenzone, which degrades quickly on its own.",
     f:"A modern filter used to hold an older one together, so an SPF 50 is still an SPF 50 after two hours outdoors.",
     i:["Dermdefence SPF 50","Dermatint SPF 50"]},
    {s:"IG",n:"Infraguard®",c:"Photoprotection",p:"—",
     t:"Reactive oxygen species from visible and infrared light.",
     m:"An antioxidant complex from tara tannins and sunflower sprouts, included for the part of the spectrum a UV filter does not cover — high-energy visible light and infrared.",
     f:"Sunscreen that stops at UV is an incomplete answer for pigmentation, which responds to visible light as well.",
     i:["Dermatint SPF 50","Dermdefence SPF 50"]},

    {s:"PT",sn:"Matrixyl 3000",n:"Matrixyl 3000 peptides",c:"Peptide",p:"—",
     t:"Extracellular matrix signalling.",
     m:"Palmitoyl tripeptide-1 and tetrapeptide-7, reported to signal toward matrix repair — a different lever from the retinoid alongside them.",
     f:"Combined with a retinoid rather than sold instead of one. Peptides are a supporting mechanism, and we are not going to pretend otherwise.",
     i:["Retinol Serum"]},
    {s:"AH",sn:"Acetyl hexapeptide-8",n:"Acetyl hexapeptide-8",c:"Peptide",p:"—",
     t:"The tension behind expression lines.",
     m:"Reported to modulate the neural signalling that keeps facial muscles under tension, softening the surface crease that repeated movement produces.",
     f:"Used for texture and surface tension around the eye, where it does the most visible work.",
     i:["Retinol Serum","Time Freeze Eye Serum"]}
  ];

  var classes=[]; E.forEach(function(e){ if(classes.indexOf(e.c)<0) classes.push(e.c); });
  filters.innerHTML='<button class="dxp-opt on" type="button" data-f="all">All ('+E.length+')</button>'+
    classes.map(function(c){ return '<button class="dxp-opt" type="button" data-f="'+c+'">'+c+'</button>'; }).join("");

  grid.innerHTML=E.map(function(e,i){
    return '<button class="dxp-el" type="button" data-i="'+i+'" data-c="'+e.c+'" aria-label="'+e.n+'">'+
      '<span class="dxp-el__n">'+String(i+1).padStart(2,"0")+'</span>'+
      (e.p!=="—" ? '<span class="dxp-el__pct">'+e.p+'</span>' : '')+
      '<span class="dxp-el__sym">'+e.s+'</span>'+
      '<span class="dxp-el__nm">'+(e.sn||e.n)+'</span>'+
      '<span class="dxp-el__bar"></span></button>';
  }).join("");

  filters.querySelectorAll(".dxp-opt").forEach(function(b){
    b.addEventListener("click",function(){
      filters.querySelectorAll(".dxp-opt").forEach(function(x){x.classList.remove("on");});
      b.classList.add("on");
      var f=b.getAttribute("data-f");
      grid.querySelectorAll(".dxp-el").forEach(function(el){
        el.classList.toggle("dim", f!=="all" && el.getAttribute("data-c")!==f);
      });
    });
  });

  var cur=-1;
  function open(i){
    var e=E[i];
    doc.getElementById("elSym").textContent=e.s;
    doc.getElementById("elClass").textContent=e.c;
    doc.getElementById("elName").textContent=e.n;
    doc.getElementById("elUse").textContent=e.p!=="—" ? e.c+" · up to "+e.p+" in range" : e.c;
    doc.getElementById("elTarget").textContent=e.t;
    doc.getElementById("elMech").textContent=e.m;
    doc.getElementById("elForm").textContent=e.f;
    doc.getElementById("elIn").innerHTML=e.i.map(function(x){return "<span>"+x+"</span>";}).join("");
    panel.classList.add("open");
    grid.querySelectorAll(".dxp-el").forEach(function(el){ el.classList.toggle("on", +el.getAttribute("data-i")===i); });
    cur=i;
  }
  grid.querySelectorAll(".dxp-el").forEach(function(el){
    el.addEventListener("click",function(){
      var i=+el.getAttribute("data-i");
      if(i===cur){ panel.classList.remove("open"); el.classList.remove("on"); cur=-1; return; }
      open(i);
    });
  });
  stagger("#elGrid","#elGrid .dxp-el",22,".9");
  open(0);
})();
})();